import { forwardRef } from "react";

import { Grow, useTheme } from "@mui/material";
import { useMediaQuery } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import { alpha, styled } from "@mui/material/styles";

const CustomizedComponent = styled(Dialog)(({ theme }) => ({
  backgroundColor: "transparent",
  boxShadow: `none`,
  color: alpha(theme.palette.foreground.contrastText, 0.25),
  transform: "scale(1)",
  transformOrigin: "center",
  transition: "all 0.05s ease-out",
  borderRadius: 4,
}));

const Transition = forwardRef(function Transition(props, ref) {
  return <Grow direction="up" ref={ref} {...props} />;
});

const OmniDialog = props => {
  const { children, ...other } = props;
  const theme = useTheme();
  const matches = useMediaQuery(theme => theme.breakpoints.down("sm"));

  return (
    <CustomizedComponent
      TransitionComponent={Transition}
      fullScreen={matches}
      disableEscapeKeyDown
      hideBackdrop
      PaperProps={{
        style: {
          borderRadius: theme.spacing(1.5),
          overflowY: "hidden",
        },
      }}
      scroll={"paper"}
      {...other}
    >
      {children}
    </CustomizedComponent>
  );
};

export default OmniDialog;
